module.exports = __webpack_public_path__ + "img/power-02.028750c7.svg";